import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromTvChannels from './tv-channels.reducer';

export interface State {
  tvChannels: fromTvChannels.TvChannelsState;
}

export const reducers: ActionReducerMap<State> = {
  tvChannels: fromTvChannels.tvChannelReducer,
};

export const selectTvChannelsState = createFeatureSelector<fromTvChannels.TvChannelsState>(
  fromTvChannels.inRoomTvChannelsFeatureKey
);

export const selectTvChannelsEntities = createSelector(selectTvChannelsState, fromTvChannels.selectTvChannelEntities);

export const getTvChannel = (tvChannelId: string) =>
  createSelector(selectTvChannelsEntities, (entities) => entities[tvChannelId]);
